import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfd5ac52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-md-end align-items-center"
}
const _hoisted_2 = { class: "base-price__label" }
const _hoisted_3 = { class: "base-price__price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.basePriceConfig.basePriceInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.basePriceConfig.basePriceInfo.label) + ": ", 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.basePriceConfig.basePriceInfo.price) + " CHF ", 1)
      ]))
    : _createCommentVNode("", true)
}